/** PARTIAL DISPATCH + WAREHOUSE HOLD — per line: how many to DEPLOY now and how many to STORE. Same quote, no extra transactions. */
import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { OpsBlock } from "./OpsTop";

const n0 = (v) => String(Number(v || 0)).replace(/\.0+$/, "");

export function PartialSplit({ orderId, ordered, reload }) {
  const [lines, setLines] = useState(null);
  const [v, setV] = useState({});
  const load = useCallback(() => api.get(`/warehouse-receiving/orders/${orderId}`).then(({ data }) => { setLines(data.expected); setV(Object.fromEntries(data.expected.map((e) => [e.id, n0(e.expected_qty)]))); }).catch(() => setLines([])), [orderId]);
  useEffect(() => { load(); }, [load]);
  if (!lines) return null;
  const save = async (e) => {
    const q = Number(v[e.id]);
    if (Number.isNaN(q) || q === Number(e.expected_qty)) return;
    try { await api.put(`/warehouse-receiving/expected/${e.id}`, { expected_qty: q }); toast.success(`${e.product_name}: store ${n0(q)} · deploy the rest`); load(); reload(); } catch (x) { toast.error(x.response?.data?.detail || x.message); setV({ ...v, [e.id]: n0(e.expected_qty) }); }
  };
  const store = lines.reduce((a, e) => a + Number(e.expected_qty || 0), 0);
  return (
    <OpsBlock id="ops-split" title="Deploy now or store in the warehouse" done={lines.length > 0}>
      {!lines.length ? <div className="text-[12px] text-slate-500" data-testid="ops-split-empty">Lines to store appear here automatically from the quotation.</div> : (
        <div className="space-y-1.5" data-testid="ops-split">
          {lines.map((e) => {
            const line = Number(e.ordered_qty || e.line_qty || 0);
            return (
              <div key={e.id} className="flex flex-wrap items-center gap-3 rounded-lg border border-slate-200 px-3 py-2 text-[12px]" data-testid={`ops-split-${e.id}`}>
                <div className="min-w-[200px] flex-1 font-semibold text-slate-900">{e.product_name}{line ? <span className="ml-1 font-normal text-slate-500">· ordered {n0(line)}</span> : null}</div>
                <label className="flex items-center gap-1.5 text-slate-600">STORE<input value={v[e.id] ?? ""} onChange={(x) => setV({ ...v, [e.id]: x.target.value.replace(/[^\d.]/g, "") })} onBlur={() => save(e)} onKeyDown={(x) => x.key === "Enter" && save(e)} className="h-9 w-20 rounded-md border border-slate-300 px-2 text-center font-mono text-[14px]" data-testid={`ops-split-store-${e.id}`} /></label>
                {line > 0 && <span className="rounded-full bg-sky-50 px-2.5 py-1 text-[11px] font-bold text-sky-900" data-testid={`ops-split-deploy-${e.id}`}>DEPLOY {n0(Math.max(0, line - Number(v[e.id] || 0)))}</span>}
                <span className="text-[11px] text-slate-500">received {n0(e.received_qty)}</span>
              </div>
            );
          })}
          <div className="text-[11px] text-slate-600" data-testid="ops-split-total">Storing {n0(store)} of {n0(ordered)} · the remaining {n0(Math.max(0, ordered - store))} go to recipients below.</div>
        </div>)}
    </OpsBlock>
  );
}
